<template>
  <div style="height: 90%; width: 100%">
    <v-layout>
      <v-col cols="auto" v-for="(software, id) in softwareData" :key="id">
        <v-checkbox
          v-model="selected"
          :label="software"
          :value="id"
        ></v-checkbox>
      </v-col>
    </v-layout>
    <div style="height: 100%; width: 100%">
      <l-map
        ref="map"
        style="height: 100%; width: 100%"
        :zoom="zoom"
        :center="center"
        @update:zoom="zoomUpdated"
        @update:center="centerUpdated"
        @update:bounds="boundsUpdated"
      >
        <l-tile-layer :url="url"></l-tile-layer>
        <heat-map
          :latLngs="coordinates"
          :minOpacity="minOpacity"
          :max="3"
          :maxZoom="10"
        >
        </heat-map>
        <marker-cluster-map :latLngs="coordinates"></marker-cluster-map>
      </l-map>
      <div>zoom: {{ zoom }}, center: {{ center }}</div>
    </div>
  </div>
</template>

<script>
import HeatMap from "./HeatMap.vue";
import { LMap, LTileLayer } from "vue2-leaflet";
import MarkerClusterMap from "./MarkerClusterMap.vue";
import { mapGetters, mapActions } from "vuex";
import SOFTWARE_CODES from '../../constants.js'

export default {
  components: {
    HeatMap,
    MarkerClusterMap,
    LMap,
    LTileLayer,
  },
  data() {
    return {
      minOpacity: 0.5,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 11.6,
      center: [55.011, 82.978],
      bounds: null,
      selected: SOFTWARE_CODES,
    };
  },
  watch: {
    selected: {
      handler(newVal) {
        this.createCoordinates({
          software_codes: newVal,
        });
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["coordinates", "softwareData"]),
  },
  async created() {
    await this.createCoordinates({
      software_codes: this.selected,
    });
    await this.createSoftwareData();
  },
  methods: {
    ...mapActions(["createCoordinates", "createSoftwareData"]),
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
  },
};
</script>

<style>
.leaflet-bottom {
  visibility: hidden;
}
</style>
